import { withDevtools } from '@angular-architects/ngrx-toolkit';
import { inject, Signal } from '@angular/core';
import { AddFuncRoleAssignment, Attribute, FuncRoleAssignment } from '@models/authorization';
import { signalStore, withMethods, withState } from '@ngrx/signals';
import { addEntity, createStateResetHandler, deleteEntity, getAllWithParams, StateDictionary } from '../../helpers';
import { FunctionalRolesService } from './functional-roles.service';

type FunctionalRolesState = {
  isLoading: boolean;
  createLoading: boolean;
  assignments: FuncRoleAssignment[];
};

const initialState: FunctionalRolesState = {
  isLoading: false,
  createLoading: false,
  assignments: [],
};

const functionalRolesAssignmentsDictionary: StateDictionary<FuncRoleAssignment> = {
  entityList: 'assignments',
  listLoading: 'isLoading',
  createLoading: 'createLoading',
  selectedEntity: '',
  selectedEntityLoading: '',
  entityId: 'assignmentId',
  sortFn: (a, b) => a.userEmail.localeCompare(b.userEmail),
};

export const FunctionalRolesStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withDevtools('functional-roles-store'),

  withMethods((store, functionalRolesService = inject(FunctionalRolesService)) => {
    createStateResetHandler<FunctionalRolesState>('/functional-roles')(store, initialState);
    const assignmentMethods = {
      getAll: getAllWithParams<FuncRoleAssignment, { subtype: string; attributes: Attribute[] }>({
        store,
        service: functionalRolesService,
        dictionary: functionalRolesAssignmentsDictionary,
      }),

      addFuncRoleAssignment: addEntity<FuncRoleAssignment, { addFuncRoleAssignment: AddFuncRoleAssignment; subtype: string }>({
        store,
        service: functionalRolesService,
        dictionary: functionalRolesAssignmentsDictionary,
      }),

      deleteFuncRoleAssignment: deleteEntity<FuncRoleAssignment>({
        store,
        service: functionalRolesService,
        dictionary: functionalRolesAssignmentsDictionary,
      }),
    };

    return {
      ...assignmentMethods,
    };
  }),
);

export interface FunctionalRolesStoreType {
  readonly isLoading: Signal<boolean>;
  readonly createLoading: Signal<boolean>;
  readonly assignments: Signal<FuncRoleAssignment[]>;

  readonly getAll: (params: { subtype: string; attributes: Attribute[] }) => void;
  readonly addFuncRoleAssignment: (params: { addFuncRoleAssignment: AddFuncRoleAssignment; subtype: string }) => void;
  readonly deleteFuncRoleAssignment: (id: string) => void;
}
